import gql from 'graphql-tag';

const singleUserFragment = gql`
    fragment UserFragment on UserNode {
        id
        email
        fullName
        unitSystem
    }
`;

export default singleUserFragment;